module.exports = __webpack_public_path__ + "img/logo-big-picture-medical-regular.5853ebe2.svg";